import * as React from "react";
import {
  CircularProgress,
  Container,
  PaletteMode,
  Typography,
} from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import AppAppBar from "../components/AppAppBar";
import BoxAi from "../components/BoxAi";
import FAQ from "../components/FAQ";
import getLPTheme from "./getLPTheme";
import { SizeType } from "antd/es/config-provider/SizeContext";
import { MyContextType, Context } from "../context/context";
import { promptFeedback } from "../network/prompt";
import convertElementToPDF from "../helper/convertPDF";
import { useEffect } from "react";
import {
  sxMainBox,
  sxToggleButtonGroup,
  sxLoadingViewBox,
  sxEmptyViewBox as sxEmptyViewContainer,
} from "./LandingPage-sx";
import ResultDataView from "../components/ResultDataView";
import { useSnackbar } from "notistack";
import {
  handleUploadedSkills,
  handleUploadedfeedbacks,
  clearAll,
} from "../pages/LandingPageViewModel";

interface ToggleCustomThemeProps {
  showCustomTheme: Boolean;
  toggleCustomTheme: () => void;
}

function ToggleCustomTheme({
  showCustomTheme,
  toggleCustomTheme,
}: ToggleCustomThemeProps) {
  return (
    <Box sx={sxMainBox}>
      <ToggleButtonGroup
        color="primary"
        exclusive
        value={showCustomTheme}
        onChange={toggleCustomTheme}
        aria-label="Platform"
        sx={sxToggleButtonGroup}
      >
        <ToggleButton value>
          <AutoAwesomeRoundedIcon sx={{ fontSize: "20px", mr: 1 }} />
          Custom theme
        </ToggleButton>
        <ToggleButton value={false}>Material Design 2</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}

export default function LandingPage() {
  const [mode, setMode] = React.useState<PaletteMode>("light");
  const [showCustomTheme, setShowCustomTheme] = React.useState(true);
  const LPtheme = createTheme(getLPTheme(mode));
  const defaultTheme = createTheme({ palette: { mode } });
  const { onSent, loading, resultData } =
    React.useContext<MyContextType>(Context);

  const [size, setSize] = React.useState<SizeType>("middle"); // large - middle - small
  const [uploadedSkills, setUploadedSkills] = React.useState<string>("");
  const [uploadedFeedback, setUploadedFeedback] = React.useState<string>("");
  const [bottomView, setBottomView] = React.useState<JSX.Element>(
    <CircularProgress />
  );

  const resultViewRef = React.useRef<HTMLDivElement>(null);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (loading === true) {
      setBottomView(
        <Box sx={sxLoadingViewBox}>
          <CircularProgress />
        </Box>
      );
    } else if (resultData.length === 0) {
      setBottomView(
        <Container sx={sxEmptyViewContainer}>
          <Typography variant="caption" textAlign="center">
            O resultado do análise aparecerá aqui.
          </Typography>
        </Container>
      );
    } else if (resultData.length !== 0 && loading === false) {
      setBottomView(
        ResultDataView(resultData, callAi, downloadPDF, resultViewRef, clearAll)
      );
    } else {
      setBottomView(<CircularProgress />);
    }
  }, [loading]);

  async function callAi() {
    console.log(prompt + uploadedSkills + uploadedFeedback);

    onSent(promptFeedback + uploadedSkills + uploadedFeedback);
  }

  function uploadSkills() {
    // This code snippet creates a new input element of type file,
    // which allows the user to select files from their device.
    const input = document.createElement("input");
    input.type = "file";

    input.click();

    handleUploadedSkills(input, setUploadedSkills, enqueueSnackbar);
  }

  function uploadFeedbacks() {
    // This code snippet creates a new input element of type file,
    // which allows the user to select files from their device.
    const input = document.createElement("input");
    input.type = "file";

    input.click();

    handleUploadedfeedbacks(input, setUploadedFeedback, enqueueSnackbar);
  }

  function downloadPDF(): void {
    convertElementToPDF(resultViewRef);
  }

  const toggleColorMode = () => {
    setMode((prev) => (prev === "dark" ? "light" : "dark"));
  };

  const toggleCustomTheme = () => {
    setShowCustomTheme((prev) => !prev);
  };

  return (
    <ThemeProvider theme={showCustomTheme ? LPtheme : defaultTheme}>
      <CssBaseline />
      <AppAppBar mode={mode} toggleColorMode={toggleColorMode} />
      <BoxAi
        callAi={callAi}
        uploadSkills={uploadSkills}
        uploadFeedbacks={uploadFeedbacks}
        uploadedSkills={uploadedSkills}
        uploadedFeedback={uploadedFeedback}
        resultData={resultData}
        bottomView={bottomView}
        loading={loading}
      />
      <Box sx={{ bgcolor: "background.default" }}>
        {/* <LogoCollection /> */}
        {/* <Features /> */}
        {/* <Divider /> */}
        {/* <Testimonials /> */}
        {/* <Divider /> */}
        {/* <Highlights /> */}
        {/* <Divider /> */}
        {/* <Pricing /> */}

        <Divider />
        <FAQ />
        {/* <Divider />
        <Footer /> */}
      </Box>
      {/* <ToggleCustomTheme
        showCustomTheme={showCustomTheme}
        toggleCustomTheme={toggleCustomTheme}
      /> */}
    </ThemeProvider>
  );
}
